require('./bootstrap');

window.imageMapResize = require('image-map-resizer');

imageMapResize();

import EventPing from "./event-ping";
window.EventPing = new EventPing();
